<template>
  <div>
    <div
      v-if="$route.name === 'home'"
      class="primary"
      style="padding: 80px 0"
    >
      <v-img
        :src="require('../assets/images/mv-digital-logo.svg')"
        height="48px"
        contain
      />
    </div>

    <v-container fluid>
      <h1 class="primary--text my-3">Ahoi! Alles wichtige im Überblick:</h1>
      <v-layout row fill-height>
        <v-flex>
          <v-list three-line>
            <template v-for="(item, index) in items">
              <v-subheader
                v-if="item.header"
                :key="item.header"
              >
                {{ item.header }}
              </v-subheader>

              <v-divider
                v-else-if="item.divider"
                :key="index"
                :inset="item.inset"
              />

              <v-list-tile
                v-else
                :key="item.title"
                avatar
                @click="$router.push({ name: item.target })"
              >
                <v-icon large color="accent" class="pr-3">{{ item.avatar }}</v-icon>

                <v-list-tile-content>
                  <v-list-tile-title v-html="item.title" />
                  <v-list-tile-sub-title v-html="item.subtitle" />
                </v-list-tile-content>
              </v-list-tile>
            </template>
          </v-list>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  data () {
    return {
      items: [
        {
          avatar: 'access_time',
          title: 'Programm',
          subtitle: '08:00 bis 17:00 Uhr',
          target: 'schedule'
        },
        { divider: true },
        {
          avatar: 'mood',
          title: 'Speaker',
          subtitle: 'Alle Speaker anzeigen',
          target: 'lineup'
        },
        { divider: true },
        {
          avatar: 'grade',
          title: 'Gastgeber und Unterstützer',
          subtitle: 'Erfahre mehr über unsere Unterstützer',
          target: 'sponsors'
        },
        { divider: true },
        {
          avatar: 'book',
          title: 'Verlagspartner',
          subtitle: 'Mehr Wissen',
          target: 'publishers'
        }
      ]
    }
  }
}
</script>
